const handler = ( $ ) => {

	$( '.wpcf7' ).on( 'wpcf7submit', function( e ) {
		
		setTimeout( function() {
			const $form = $( e.target );
			$form.find('.wpcf7-form-control').parent().removeClass('is-invalid-field');
			$form.find('.wpcf7-not-valid').parent().addClass('is-invalid-field');
		}, 100 );
		
	});

	let timeout;
	$( '.wpcf7' ).find( 'input, textarea').on( 'blur', function() {

		const $el = $(this);

		setTimeout( function() {
			
			if( $el.hasClass('wpcf7-not-valid') ) {
				$el.parent().addClass('is-invalid-field');
			} else {
				$el.parent().removeClass('is-invalid-field');
			}
		}, 100 );

	});

};

( ( $ ) => {
	$( handler );
} )( jQuery );
